<template>
  <main role="main" class="py-4">
    <b-container class="mb-3">
      <div class="d-flex flex-row align-items-center justify-content-between mb-4">
        <h4 class="m-0">{{ $t("subPlanList") }}</h4>
      </div>

      <div class="d-flex flex-row align-items-center justify-content-between mb-4">
        <b-form-radio-group v-model="selectedTab" :options="tabOptions" buttons button-variant="outline-primary" @change="onSelectTab"/>
        <div>
          <span v-if="subscriptionPlans && subscriptionPlans.length" class="mr-3">{{ $t("resultCount", { count: subscriptionPlans.length }) }}</span>
          <b-button variant="outline-secondary" @click="onClickReload">
            <b-icon icon="arrow-clockwise"></b-icon> {{ $t("reload") }}
          </b-button>
          <b-button class="ml-4" variant="outline-primary" to="/subscription-plans/new" v-if="isUserAdmin()">
            <b-icon icon="plus"></b-icon> {{ $t("createNew") }}
          </b-button>
        </div>
      </div>

      <div v-if="isLoading" class="text-center py-5"><b-spinner type="grow"/></div>

      <div v-if="subscriptionPlans && subscriptionPlans.length">
        <div v-for="plan in subscriptionPlans" :key="plan.id"
             class="px-4 py-3 my-4 border rounded subscription-plan-item position-relative"
             :class="{ 'text-secondary': !plan.active }">
          <b-row class="align-items-center mb-2">
            <b-col md="4">
              <h4>{{ plan.name }}</h4>
              <div>{{ formatCurrencyAmount(plan.price) }} VND / {{ plan.numberOfDaysUsage }} {{ $t(plan.unitTime+'s') }}</div>
            </b-col>
            <b-col md="4">
              <div>
                <b-icon icon="camera-video" class="mr-2"/>
                {{ $t("displayActiveSubMeetingCount", { count: plan.numberOfMeetingsPerMonth }) }}
              </div>
              <div>
                <b-icon icon="blank" class="mr-2"/>
                {{ $t("displayActiveSubConcurrentMeetings", { count: plan.numberOfConcurrentMeetings }) }}
              </div>
            </b-col>
            <b-col md="4">
              <div>
                <b-icon icon="people" class="mr-2"/>
                {{ $t("displayActiveSubMaxParticipants", { count: plan.maximumNumberOfParticipantsInMeeting }) }}
              </div>
              <div>
                <b-icon icon="clock" class="mr-2"/>
                {{ $t("displayActiveSubMaxMeetingLength", { count: plan.maximumLengthOfOneMeeting }) }}
              </div>
              <!--<div>
                <b-icon icon="cloud" class="mr-2"/>
                {{ plan.storageGbLimit }}GB lưu trữ
              </div>-->
            </b-col>
          </b-row>
          <b-row class="small" v-if="false">
            <!--<b-col xl="3" lg="4">
              <span class="text-secondary">Kích hoạt từ ngày:</span> 13/08/2020
            </b-col>
            <b-col xl="3" lg="4" v-if="!plan.active">
              <span class="text-secondary">Đã huỷ từ ngày:</span> 05/09/2020
            </b-col>-->
            <b-col xl="3" lg="4">
              <span class="text-secondary">{{ $t("coreImplName") }}:</span> {{ plan.coreImplName }}
            </b-col>
            <!--<b-col xl="3" lg="4">
              <span class="text-secondary">Người tạo:</span> Võ Văn Anh
            </b-col>-->
          </b-row>

          <!--<b-button v-if="plan.active" :to="'/subscription-plans/edit/' + plan.id" class="position-absolute"
                    variant="outline-primary" size="sm" style="top: 0; right: 0;">
            <b-icon icon="pencil-square"></b-icon>
          </b-button>-->
          <b-dropdown v-if="isUserAdmin()" class="position-absolute" no-caret right menu-class="shadow"
                      variant="link" style="top: 0; right: 0;">
            <template v-slot:button-content>
              <b-icon icon="chevron-down"></b-icon>
            </template>
            <b-dropdown-item :to="'/subscription-plans/edit/' + plan.id">{{ $t("update") }}</b-dropdown-item>
            <b-dropdown-item-button @click="onClickDeletePlan(plan)">{{ $t("actionDelete") }}</b-dropdown-item-button>
          </b-dropdown>
        </div>
      </div>

      <div v-if="subscriptionPlans && !subscriptionPlans.length" class="text-center py-5">
        <span class="text-secondary">{{ $t("noData") }}</span>
      </div>

    </b-container>
  </main>
</template>

<style lang="scss" scoped>
  .subscription-plan-item {
    font-size: 18px;
    line-height: 175%;
  }
</style>

<script lang="ts">
  import {Component, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";
  import {BvTableFieldArray} from "bootstrap-vue";

  import * as subscriptionPlanService from "@/service/subscriptionPlanService";
  import * as util from "@/service/util";

  @Component
  export default class SubscriptionPlans extends BaseComponent {

    tabOptions = [
      { value: true, text: this.$t("activeSubPlans").toString() },
      { value: false, text: this.$t("inactiveSubPlans").toString() },
    ];
    selectedTab = true;

    isLoading = false;
    subscriptionPlans: any[] = null;


    mounted() {
      this.fetchPlans();
      this.onSelectTab(1);
    }

    onSelectTab(tab) {
      this.fetchPlans(tab);
    }

    async fetchPlans(active = true) {
      try {
        this.isLoading = true;
        this.subscriptionPlans = null;
        this.subscriptionPlans = await subscriptionPlanService.getPlans(active);

      } catch (e) {
        this.toastError(e);

      } finally {
        this.isLoading = false;
      }
    }

    onClickReload() {
      this.fetchPlans(this.selectedTab);
    }

    async onClickDeletePlan(plan) {
      const modalMessage = this.$t("deleteSubPlanConfirm", { name: plan.name, id: plan.id }).toString();
      const confirmDelete = await this.$bvModal.msgBoxConfirm(modalMessage, {
        okVariant: 'danger',
        okTitle: this.$t("yes").toString(),
        cancelTitle: this.$t("no").toString(),
      });

      if (confirmDelete) {
        try {
          this.isLoading = true;
          await subscriptionPlanService.deletePackage(plan.id);
          this.toastSuccessDelay(this.$t("deleteSubPlanSuccessful").toString());

        } catch (e) {
          this.toastError(e);

        } finally {
          this.fetchPlans(this.selectedTab);
        }
      }
    }

  }
</script>
